import type { AGENTIC_VERBS, Summary } from '../claims/interface';

export const TIMEOUT_MS = 600_000;

export const search = (data: {
  dossierId: string;
  query: string;
  dataVersion?: string;
  threadId: string | null;
}): WebSocket => {
  return new WebSocket(
    new URL(`/app/v1/dossiers/${data.dossierId}/search`, API_BASE_URL).href
  );
};

export const agenticSearch = (data: {
  dossierId: string;
  selected_text: string;
  summary: Summary;
  data_version?: string;
  verbs: AGENTIC_VERBS[];
  thread_id?: string;
}): WebSocket => {
  return new WebSocket(
    new URL(
      `/app/v1/dossiers/${data.dossierId}/agentic_search`,
      API_BASE_URL
    ).href
  );
};
